<script setup lang="ts">
import { showTrustpilotWidget } from '~/composables/showTrustpilotWidget'
import { useTrustpilotReady } from '~/composables/useTrustpilotReady'

const props = defineProps<{ widgetHtml?: string, alwaysCookieless?: boolean }>()

const { ready } = useTrustpilotReady()

// Cookieless is the SSR default and the fallback until the GTM container has
// loaded the Trustpilot script; the real widget swaps in once it's ready. SSR
// and the first client render stay cookieless (ready is false) — no mismatch.
const showWidget = computed(() => showTrustpilotWidget({
  ready: ready.value,
  hasWidgetHtml: !!props.widgetHtml,
  alwaysCookieless: !!props.alwaysCookieless,
}))
</script>

<template>
  <TrustpilotWidget
    v-if="showWidget"
    :html="widgetHtml!"
  />
  <slot v-else />
</template>
